import styled from 'styled-components';
import { Box } from '../../common/Box';
import BackgroundImage from 'assets/backgrounds/recommendations.jpg';
import { Typography } from '../../common/Typography';
import { SIZES } from 'theme/sizes';

export const StyledContainer = styled(Box)`
  background-image: url(${BackgroundImage});
  background-size: cover;
  background-position-x: 89%;

  height: fit-content;
  padding: ${SIZES.spacing(8)} ${SIZES.spacing(2.5)};

  ${SIZES.media.tablet} {
    padding: ${SIZES.spacing(12.5)} 0;
    background-position-x: unset;
  }
`;

export const StyledDescription = styled(Typography)`
  line-height: 25px;

  ${SIZES.media.tablet} {
    width: 60%;
  }
`;

export const StyledTypography = styled(Typography)`
  font-size: 32px;
  line-height: 38px;

  ${SIZES.media.tablet} {
    font-size: 48px;
    line-height: 58px;
  }
`;
